var Config = {
   LIMIT: "10",
   PERSIST_SECRET_KEY: "123456abcdef",
   ENVIRONMENT: "DEVELOPMENT",
   ENVIRONMENTS: {
      LOCAL: {
         API_URL: "https://dev-api.casita.kodefuse.com/v1",
         DOMAIN_URL: "https://dev-admin.casita.kodefuse.com",
         CONFIGURATOR_WEB_URL: "https://dev-configurator-tool.casita.kodefuse.com",
      },
      DEVELOPMENT: {
         API_URL: "https://dev-api.casita.kodefuse.com/v1",
         DOMAIN_URL: "https://dev-admin.casita.kodefuse.com",
         CONFIGURATOR_WEB_URL: "https://dev-configurator-tool.casita.kodefuse.com",
      },
      STAGING: {
         API_URL: "https://dev-api.casita.kodefuse.com/v1",
         DOMAIN_URL: "https://dev-admin.casita.kodefuse.com",
         CONFIGURATOR_WEB_URL: "https://dev-configurator-tool.casita.kodefuse.com",
      },
      DEMO: {
         API_URL: "https://dev-api.casita.kodefuse.com/v1",
         DOMAIN_URL: "https://dev-admin.casita.kodefuse.com",
         CONFIGURATOR_WEB_URL: "https://dev-configurator-tool.casita.kodefuse.com",
      },
      PRODUCTION: {
         API_URL: "https://dev-api.casita.kodefuse.com/v1",
         DOMAIN_URL: "https://dev-admin.casita.kodefuse.com",
         CONFIGURATOR_WEB_URL: "https://dev-configurator-tool.casita.kodefuse.com",
      },
   },
}

Config.env = () => {
   return Config.ENVIRONMENTS[Config.ENVIRONMENT]
}

export default Config